module.exports = __webpack_public_path__ + "img/word_video.c0388cfe.png";